//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class MediaGalleryItem extends ItemBase {
    Name: string | null = null;
    Size: number = 0;
    Extension: string | null = null;
    LastModified: string = "1970-01-01T00:00:00";
    ThumbUrl: string | null = null;
    readonly SizeKB: string | null = null;

    constructor(initializer?: Partial<Omit<MediaGalleryItem, "SizeKB">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "MediaGalleryItem";
}
